import { render, staticRenderFns } from "./CommaSeparatedSpan.vue?vue&type=template&id=4e3f652d&scoped=true&"
import script from "./CommaSeparatedSpan.vue?vue&type=script&lang=js&"
export * from "./CommaSeparatedSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3f652d",
  null
  
)

export default component.exports